import { Chip, Stack } from "@mui/material";
import {
  CreateButton,
  DatagridConfigurable,
  List,
  SearchInput,
  TextField,
  TopToolbar,
  usePermissions,
  useRecordContext,
  EditButton,
  NumberField,
} from "react-admin";
import { Navigate } from "react-router";
import MyUrlFieldErp from "../Componentes/MyUrlFieldErp";
import { BuyerEmpty } from "./BuyerEmpty";

const BuyersListActions = () => (
  <TopToolbar>
    <CreateButton variant="contained" label="Novo comprador" />
  </TopToolbar>
);

const filters = [<SearchInput source="pesquisa" alwaysOn />];

const OptionsField = (_props: { label?: string | boolean }) => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <Stack direction="row" gap={1}>
      {record.administrator && (
        <Chip label="Admin" size="small" variant="outlined" color="primary" />
      )}
      {record.disabled && (
        <Chip
          label="Disabled"
          size="small"
          variant="outlined"
          color="warning"
        />
      )}
    </Stack>
  );
};

export function BuyersList() {
  const { isPending, permissions } = usePermissions();
  if (isPending) {
    return null;
  }

  if (permissions !== "admin") {
    return <Navigate to="/" />;
  }

  return (
    <Stack gap={4}>
      <List
        filters={filters}
        actions={<BuyersListActions />}
        sort={{ field: "nome_razao", order: "ASC" }}
        empty={false}
      >
        <DatagridConfigurable rowClick={false} empty={<BuyerEmpty inline />}>
          <NumberField source="id" options={{ useGrouping: false }} />
          <MyUrlFieldErp recurso="persons" source="nome_razao" alvo="id" />
          <TextField source="nome_fantasia" />
          <TextField source="email" />
          <TextField source="seg" />
          <TextField source="ter" />
          <TextField source="qua" />
          <TextField source="qui" />
          <TextField source="sex" />
          <TextField source="sab" />
          <OptionsField />
          <EditButton label="" />
        </DatagridConfigurable>
      </List>
    </Stack>
  );
}
